const Status = {
    REGULARIZADO: 1,
    SUSPENSO: 2,
    AFASTADO: 3
};

export default Status;
